import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=2c0cad40&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=ts"
export * from "./Gallery.vue?vue&type=script&lang=ts"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=2c0cad40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0cad40",
  null
  
)

export default component.exports